<script lang="ts">
	let { ratio }: { ratio: number } = $props();
</script>

<div class="icon">
	<span class="line" style={`transform: rotate(${180 * (1 - ratio)}deg)`}></span>
	<span class="line" style={`transform: rotate(${90 * (1 - ratio)}deg)`}></span>
</div>

<style lang="scss">
	.icon {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: center;
		border-radius: 50%;
		width: 40px;
		height: 40px;
		background-color: hsl(var(--color-primary));

		.line {
			position: absolute;
			background-color: hsl(var(--color-foreground));
			width: 20px;
			height: 2px;
		}
	}
</style>
